import { Component, EventEmitter, Input, OnInit, Output,ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormatsUtil } from 'src/app/utils/formats.util';

@Component({
  selector: 'app-transfer-type',
  templateUrl: './transfer-type.component.html',
  styleUrls: ['./transfer-type.component.scss']
})
export class TransferTypeComponent implements OnInit {
 selectedDeatils: any;
 @Output()
 SelectedTransType = new EventEmitter<string>();
 @Output()
 SelectedDrugDetails = new EventEmitter<string>();
 @Input() IsHistory:boolean;
 @Input() eRxModelFG:FormGroup;
 @Input() IsfrmPatHis:boolean;
 @Input() RxType:boolean;
 @Input() RequestedInfo;
 @Input() IsTransferType;
 @Input() DefaultTransferType;
 isDrugSearchopen: boolean = false;
  constructor(private _cdr: ChangeDetectorRef, public _formatsUtil:FormatsUtil) { }

  ngOnInit(): void {
    if(this.DefaultTransferType) {
        this.eRxModelFG.controls['transferType'].patchValue(this.DefaultTransferType)
    }
    if(this.RequestedInfo) // if RequestedInfo available fields should be disabled
        this.IsfrmPatHis = true;
        if(this.IsfrmPatHis){
            this.eRxModelFG.controls['transferType'].disable();
        }
  }
  openDrugSearchpopup(type?) {
    this.selectedDeatils =  null;
    this._cdr.detectChanges();
    this.selectedDeatils = type ? type :  null;
    if(type && type === "Drug" && !this.eRxModelFG.value['drugID']) {
        this.isDrugSearchopen = false;
        this._cdr.detectChanges();
        this.isDrugSearchopen = true;
    } else if(type && type === "DrugIcon") {
      this.isDrugSearchopen = false;
      this._cdr.detectChanges();
      this.isDrugSearchopen = true;
    }
    this.SelectedTransType.emit(type);
    this.SelectedDrugDetails.emit(type === "Drug" && this.eRxModelFG.value['drugID'] ? this.eRxModelFG.value['drugItem'] : null);
  }
  selectedDrug(drug) {
    this.SelectedDrugDetails.emit(drug);
    this.SelectedTransType.emit(null);
  }
}
